import React from 'react'
import { AGILE_COURSE_PAGE_1, AGILE_DETAILS_PAGE_1, AGILE_HERO_PAGE_1, BANKING_BOTTOM_CONTENT } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'
import { AGILE_ACCORDIAN_1 } from '../../../utils/courseConifg'

const AgilePage_1 = () => {
  return (
    <div className='outlet-render'>
    <CourseAsideHero  {...AGILE_HERO_PAGE_1}/>
     <CoursesAside {...AGILE_COURSE_PAGE_1}/>
     <CourseCard {...AGILE_DETAILS_PAGE_1}/>
     <Accordian {...AGILE_ACCORDIAN_1}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
   </div>
  )
}

export default AgilePage_1